import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useContext, useEffect, useState } from "react";
import Script from "next/script";
import handleEnv from "../handleEnv";
var isDevLocal = "production" === "development";
var isBS = process.env["NX_DXL_ENV"] === "bs";
var env = isDevLocal && "dev" || isBS && "bs" || "prod";
var tealiumEnv = env === "bs" && "qa" || env === "dev" && "qa" || "prod";
export var TrackingContext = /*#__PURE__*/ React.createContext({
    isReady: false,
    isReadyUtagSync: false,
    isReadyUtag: false
});
export var TrackingContextProvider = function(param) {
    var children = param.children, project = param.project;
    var ref = useState(false), isReadyUtagSync = ref[0], setIsReadyUtagSync = ref[1];
    var ref1 = useState(false), isReadyUtag = ref1[0], setIsReadyUtag = ref1[1];
    var ref2 = useState(false), isReady = ref2[0], setIsReady = ref2[1];
    var tealiumPath = project == "business" ? "it-web-business-udl" : "it-main-cdp";
    var utagUrl = handleEnv("NX_UTAG_BASE_URL") || "https://tags.tiqcdn.com/utag/vodafone/".concat(tealiumPath, "/").concat(tealiumEnv);
    useEffect(function() {
        if (isReadyUtag && isReadyUtagSync) {
            setIsReady(true);
        }
    }, [
        isReadyUtag,
        isReadyUtagSync
    ]);
    return /*#__PURE__*/ _jsx(TrackingContext.Provider, {
        /* eslint-disable-next-line react/jsx-no-constructed-context-values */ value: {
            isReady: isReady,
            isReadyUtagSync: isReadyUtagSync,
            isReadyUtag: isReadyUtag
        },
        children: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Script, {
                    id: "show-banner",
                    strategy: "afterInteractive",
                    children: "window.utag_cfg_ovrd = window.utag_cfg_ovrd || {}; window.utag_cfg_ovrd.noview = true; window.utag_data = window.utag_data || {};"
                }),
                /*#__PURE__*/ _jsx(Script, {
                    strategy: "afterInteractive",
                    defer: true,
                    src: "".concat(utagUrl, "/utag.js"),
                    onLoad: function() {
                        return setIsReadyUtag(true);
                    }
                }),
                /*#__PURE__*/ _jsx(Script, {
                    id: "wa-tealium-script",
                    strategy: "afterInteractive",
                    async: true,
                    defer: true,
                    src: "".concat(utagUrl, "/utag.sync.js"),
                    onLoad: function() {
                        return setIsReadyUtagSync(true);
                    }
                }),
                children
            ]
        })
    });
};
export var useTrackingProvider = function() {
    return useContext(TrackingContext);
};
